module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-MEDIUM.a055afc4.png";